export function FullPageSpinner() {
  return (
    <div
      className="grid min-h-screen place-items-center"
      role="status"
      aria-label="Loading application"
    >
      <div className="border-brand-500 size-10 animate-spin rounded-full border-4 border-r-transparent" />
    </div>
  );
}
